<ion-content class="ion-padding">

    <h5 class="ion-text-center" [innerHTML]="'DELETE_DETAIL_PROMPT' | translate"></h5>
    <p class="ion-text-center" [innerHTML]="'DELETE_DETAIL_SUBPROMPT' | translate"></p>

    <ion-list>
        <ion-item (click)="onClickItem(item.id)" *ngFor="let item of deleteItems"
            [class.selected]="deleteVal === item.id">
            <p clss="ion-text-wrap" [innerHTML]="item.text"></p>
        </ion-item>
    </ion-list>

</ion-content>

<ion-footer class="button-row">
    <ion-row>
        <ion-col size="6"><ion-button expand="full" fill="clear" (click)="dismiss()" [innerHTML]="'BUTTON_CANCEL' | translate"></ion-button></ion-col>
        <ion-col size="6"><ion-button expand="full" fill="clear" (click)="confirm()" [innerHTML]="'BUTTON_DELETE' | translate" [disabled]="valid === false"></ion-button></ion-col>
    </ion-row>
</ion-footer>